import { render } from "./Catalogo.vue?vue&type=template&id=170f197c&scoped=true"
import script from "./Catalogo.vue?vue&type=script&lang=js"
export * from "./Catalogo.vue?vue&type=script&lang=js"

import "./Catalogo.vue?vue&type=style&index=0&id=170f197c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170f197c"]])

export default __exports__